import Layout from '../views/layout/Layout'

export default {
  path: '/setting',
  component: Layout,
  redirect: '/setting/faceSetList',
  name: 'setting',
  meta: {title: '系统设置', icon: 'setting'},
  children: [
    {
      path: 'faceSetList',
      name: 'faceSetList',
      component: () => import('@/views/setting/faceSetList/index'),
      meta: {title: 'FaceSet列表', icon: 'faceset'}
    },
    {
      path: 'cityList',
      name: 'cityList',
      component: () => import('@/views/setting/cityList/index'),
      meta: {title: '省市级联', icon: 'tree'}
    },
    {
      path: 'faceSetList/edit',
      name: 'faceSetList',
      component: () => import('@/views/setting/faceSetList/edit'),
      meta: {title: 'FaceSet信息', icon: 'software-list'},
      hidden: true
    },
    {
      path: 'cityList/edit',
      name: 'cityList',
      component: () => import('@/views/setting/cityList/edit'),
      meta: {title: '城市信息', icon: 'software-list'},
      hidden: true
    }
  ]
}


// WEBPACK FOOTER //
// ./src/router/setting.js